import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { CONTACT_DETAILS } from '../../../../utilities/constants';
import MainBodyLayout from '../partials/MainBodyLayout';
import { dynamicAssets } from '../../../../utilities/helpers';

const FALLBACK_COUNTRY = 'USA';

const NotRecognizedTx = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const getCountryContactDetails = () => {
    const { baanx } = CONTACT_DETAILS;

    return {
      baanx: baanx[FALLBACK_COUNTRY],
    };
  };

  const { baanx: baanxDetails } = getCountryContactDetails();

  const closeFlow = () => {
    history.push('/dashboard/card/details');
  };

  return (
    <MainBodyLayout withBack onPrevClick={closeFlow} title={translate('card_disabled')}>
      <img
        style={{
          width: '100%',
          height: 'auto',
          marginTop: '6rem',
          resize: 'contain',
          alignSelf: 'center',
          marginBottom: '-2rem',
        }}
        src={dynamicAssets('./assets/images/warning.svg')}
        alt="warning"
      />
      <div className="text-f5 mt-0">
        <p className="text-center">
          <Trans
            i18nKey="report_card_not_recognized_tx_info"
            values={{
              baanx_phone: baanxDetails.phone,
            }}
            components={[
              // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/control-has-associated-label
              <a
                href="./"
                key="contact-link-1"
                className="pe-none text-decoration-none text-primary"
                rel="noreferrer"
              />,
            ]}
          />
        </p>
      </div>
      <div
        className={`d-flex flex-row mt-5 pt-3 ${
          isMobile ? 'position-fixed w-95 bg-light pb-3 pe-2' : 'mx-2 px-5'
        }`}
        style={{ bottom: '0', left: '0', zIndex: 100 }}>
        <button
          onClick={() => {
            closeFlow();
          }}
          className="btn border-grey border text-f5 mt-4"
          type="button">
          {translate('btn_label_approved')}
        </button>
      </div>
    </MainBodyLayout>
  );
};

export default NotRecognizedTx;
